import { JSX } from 'react';
import { Placeholder, GetStaticComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps, PropertyDetailsStructureProps } from '@greystar/ui';
import { PageSection, PageSectionContent, LayoutContainer } from '@greystar/designsystem';
import { Property } from '@greystar/lib';

const PDPStructure = (props: PropertyDetailsStructureProps): JSX.Element => (
  <>
    <Placeholder
      name={`pdp-top-${props.params.DynamicPlaceholderId}`}
      rendering={props.rendering}
    />
    {props.data?.hasFloorPlans && props.data?.hasAvailableUnits && props.data?.hasFees && (
      <PageSection topColour="beige" isTopFlushed="true">
        <LayoutContainer flexDirection="column">
          <PageSectionContent hasMaxWidth>
            <Placeholder
              name={`pdp-middle-${props.params.DynamicPlaceholderId}`}
              rendering={props.rendering}
            />
          </PageSectionContent>
        </LayoutContainer>
      </PageSection>
    )}
    <Placeholder
      name={`pdp-bottom-${props.params.DynamicPlaceholderId}`}
      rendering={props.rendering}
    />
  </>
);

export const getStaticProps: GetStaticComponentProps = async (
  rendering,
  layoutData
): Promise<PropertyDetailsStructureProps> => {
  const props = rendering as unknown as ComponentProps;
  const property = layoutData.sitecore.context.property as Property;

  if (!property?.floorplans) {
    return {
      ...props,
      data: {
        notFound: true,
        hasAvailableUnits: false,
        hasFloorPlans: false,
        hasFees: false,
      },
    };
  }
  return {
    ...props,
    data: {
      notFound: false,
      hasAvailableUnits: !!property.availableUnits?.length,
      hasFloorPlans: !!property?.floorplans?.length,
      hasFees: !!property?.fees?.length,
    },
  };
};

export default PDPStructure;
